import { NavigateFunction } from 'react-router-dom';

import { appStore, ParentalPinType } from '@kaltura-ott/tvpil-shared';

import { NETWORK_ERROR_FOR_DISPLAY, NO_CONNECTION_MESSAGE, PLEASE_CHECK_CONNECTION_MESSAGE } from 'consts';
import { globalStorage } from 'services/globalStorage';

import { COMPONENT_NAME } from '../../constants';

interface Props {
  isConnection: boolean;
  tryToRestorePlayback(): void;
  handleRetry(): void;
  code: number;
  goBack?: NavigateFunction;
}

export const getErrorContent = ({ isConnection, tryToRestorePlayback, handleRetry, code, goBack }: Props) => {
  let errorContent;
  const goBackLink = goBack
    ? {
      goBackLink: () => {
        globalStorage.clearIsPlayerError();
        appStore.parentalPinStore.clearParentalPin(ParentalPinType.parental);
        goBack(-1);
      },
    }
    : undefined;

  if (!isConnection) {
    errorContent = {
      error: {
        titleId: `${COMPONENT_NAME}.noConnection.errorTitle`,
        titleDefault: NO_CONNECTION_MESSAGE,
        messageId: `${COMPONENT_NAME}.noConnection.checkInternet`,
        messageDefault: PLEASE_CHECK_CONNECTION_MESSAGE,
        icon: 'noConnection',
        code: NETWORK_ERROR_FOR_DISPLAY,
      },
      retryButton: {
        onRetry: tryToRestorePlayback,
        translationId: `${COMPONENT_NAME}.noConnection.buttonTitle`,
        defaultMessage: 'Try Again',
      },
      onClear: appStore.restoreAfterConnectionError.bind(appStore),
    };
  } else {
    errorContent = {
      error: {
        titleId: `${COMPONENT_NAME}.playerErrorTitle`,
        titleDefault: 'Player Error',
        messageId: `${COMPONENT_NAME}.playerErrorMessage`,
        messageDefault: 'According to a problem in player content can not be played',
        code,
      },
      retryButton: {
        onRetry: handleRetry,
        translationId: `${COMPONENT_NAME}.playerErrorButtonTryAgain`,
        defaultMessage: 'Try Again',
      },
      goBackButton: {
        ...goBackLink,
        translationId: `${COMPONENT_NAME}.playerErrorButtonBack`,
        defaultMessage: 'Back',
      },
    };
  }

  return errorContent;
};
